module.exports = __webpack_public_path__ + "static/media/metalab-motivational@2x.c8fcbdd9.png";